// extracted by mini-css-extract-plugin
export default {"text-center":"global_text-center__g3NUU","column-center":"global_column-center__B4St+","opacity-0":"global_opacity-0__4SNxm","opacity-1":"global_opacity-1__DqTb8"};